import { IStore } from '../index'
import { ILastVisitReport } from '../../interfaces/IVisitReports'

const EMPTY_REPORT = {} as ILastVisitReport

export const getClientLastVisitReport = (state: IStore, clientId?: string) =>
  clientId ? state.clientLastVisitReportReducer[clientId] : EMPTY_REPORT
